import * as CONSTANTS from "./constants";

const initialState = {
  userData: {},
  session: null,
  activeSession: null,
  completeSession: null,
  loadingSession: false,
  loadingUser: false,
  loadingFaq: false,
  loadingUpadteSession: false,
  loadingKeyValue: false,
  userUpdateLoading: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    // Sessiion managmement
    case CONSTANTS.SESSION_GET_ACTIVE_SUCCESS: {
      return {
        ...state,
        activeSession: action.payload,
        loadingUpadteSession: false,
      };
    }
    case CONSTANTS.SESSION_GET_ACTIVE_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.SESSION_GET_COMPLETE: {
      return {
        ...state,
        completeSession: action.payload,
        loadingSession: true,
      };
    }
    case CONSTANTS.SESSION_COMPLETE: {
      return {
        ...state,
      };
    }
    case CONSTANTS.SESSION_CREATE: {
      return {
        ...state,
        data: action.payload.data,
        loadingSession: true,
      };
    }
    case CONSTANTS.SESSION_FAILLED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.SESSION_UPDATE_SUCCESS: {
      return {
        ...state,
        sessionData: action.payload,
        loadingUpadteSession: true,
      };
    }
    case CONSTANTS.SESSION_UPDATE_FAILED: {
      return {
        ...state,
        access_token: null,
        loadingUpadteSession: false,
      };
    }
    case CONSTANTS.SESSION_VIEW: {
      return {
        ...state,
        sessionData: action.payload,
      };
    }
    case CONSTANTS.SESSION_DELETE: {
      return {
        ...state,
      };
    }
    case CONSTANTS.SESSION_LUNCH: {
      return {
        ...state,
        sessionData: action.payload,
      };
    }

    case CONSTANTS.MIC_DATA_SUCCESS: {
      return {
        ...state,
        sessionData: action.payload,
      };
    }
    case CONSTANTS.MIC_DATA_FAILED: {
      return {
        ...state,
        sessionData: action.payload,
      };
    }
    //ENd
    //Profile Update(users and admin)
    // case CONSTANTS.USER_PROFILEUPDATE: {
    //   return {
    //     ...state,
    //     userInfo: action.payload.data,
    //   };
    // }
    case CONSTANTS.USER_GET_ALL: {
      return {
        ...state,
        userData: action.payload,
      };
    }
    case CONSTANTS.USER_FAILLED: {
      return {
        ...state,
        userData: action.payload.user,
        access_token: null,
      };
    }
    case CONSTANTS.PASSWORD_UPDATE: {
      return {
        ...state,
        isUpdated: action.payload,
      };
    }
    case CONSTANTS.PASSWORD_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    //End

    //User Mangament
    case CONSTANTS.UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUser: action.payload,
        userUpdateLoading: true,
      };

    case CONSTANTS.UPDATE_USER_FAILED: {
      return { ...state, access_token: null, userUpdateLoading: false };
    }

    case CONSTANTS.GET_ONE_USER:
      return {
        ...state,
        getOneUser: action.payload,
      };

    case CONSTANTS.CREATE_USER:
      return {
        ...state,
        data: action.payload,
        loadingUser: true,
      };
    case CONSTANTS.DELETE_USER:
      return {
        data: action.payload,
      };

    case CONSTANTS.USER_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.CREATE_SOP: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.VEIW_SOP: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.EDIT_SOP: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DOWNLOAD_SOP: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.FAILED_SOP: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.CREATE_FAQ_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loadingFaq: true,
      };
    }
    case CONSTANTS.CREATE_FAQ_FAILED: {
      return {
        ...state,
        access_token: null,
        loadingFaq: false,
      };
    }

    case CONSTANTS.GET_ALL_FAQ_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loadingFaq: false,
      };
    }
    case CONSTANTS.GET_ALL_FAQ_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }

    case CONSTANTS.DELETE_FAQ_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_FAQ_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }

    case CONSTANTS.GET_QUESTION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.GET_QUESTION_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.RELEVANT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.RELEVANT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.GET_ALL_MARKED_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.GET_ALL_MARKED_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    //video management
    case CONSTANTS.CREATE_VIDEO_SESSION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.CREATE_VIDEO_SESSION_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.FETCH_VIDEO_SESSION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.FETCH_VIDEO_SESSION_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DELETE_VIDEO_SESSION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_VIDEO_SESSION_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.GENERATE_IMAGE_SCRIPT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.GENERATE_IMAGE_SCRIPT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.UPLOAD_IMAGE_REPLACEMENT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.UPLOAD_IMAGE_REPLACEMENT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DELETE_IMAGE_SCRIPT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_IMAGE_SCRIPT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.CREATE_VIDEO_INPUT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        // loadingFaq:true
      };
    }
    case CONSTANTS.CREATE_VIDEO_INPUT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DELETE_VIDEO_INPUT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_VIDEO_INPUT_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.FETCH_VIDEO_CARD_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.FETCH_VIDEO_CARD_FAILED: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.CREATE_MERGE_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.CREATE_MERGE_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.FETCH_MERGE_VIDEO_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.FETCH_MERGE_VIDEO_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_MERGE_VIDEO_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DELETE_MERGE_VIDEO_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.FINAL_MERGE_VIDEO_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.FINAL_MERGE_VIDEO_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.LIST_MERGE_VIDEO_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.LIST_MERGE_VIDEO_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DOWNLOAD_ZIP_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DOWNLOAD_ZIP_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.GET_KEY_VALUE_SUCCESS: {
      return {
        ...state,
        access_token: null,
        loadingKeyValue:false
      };
    }
    case CONSTANTS.GET_KEY_VALUE_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.UPDATE_KEY_VALUE_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.UPDATE_KEY_VALUE_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_KEY_VALUE_SUCCESS: {
      return {
        ...state,
        access_token: null,
      };
    }
    case CONSTANTS.DELETE_KEY_VALUE_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.CREATE_KEY_VALUE_SUCCESS: {
      return {
        ...state,
        access_token: null,
        loadingKeyValue:true,
      };
    }
    case CONSTANTS.CREATE_KEY_VALUE_FAILED: {
      return {
        ...state,
        data: action.payload,
        loadingKeyValue:false,
      };
    }
    case CONSTANTS.GET_DURATION_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.GET_DURATION_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.VIDEO_ENHANCEMENT_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.VIDEO_ENHANCEMENT_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.DELETE_MERGE_LIST_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.DELETE_MERGE_LIST_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.REGENERATE_MERGE_LIST_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.REGENERATE_MERGE_LIST_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case CONSTANTS.REGENERATE_UPLOAD_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.REGENERATE_UPLOAD_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }

    case CONSTANTS.REARRANGE_VIDEOS_SUCCESS: {
      return {
        ...state,
        access_token: null,

      };
    }
    case CONSTANTS.REARRANGE_VIDEOS_FAILED: {
      return {
        ...state,
        data: action.payload,
      };
    }
    //End

    default:
      return initialState;
  }
};

export default adminReducer;
